"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AutoComplete = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _useDebounce = require("use-debounce");
var _hooks = require("../../../../hooks");
var _InputText = require("../InputText");
var _AutoCompleteNoResultsMessage = require("./AutoCompleteNoResultsMessage");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
require("./AutoComplete.scss");
const _excluded = ["name", "srInstruction", "ResultMarkup", "resultMarkupExtraProps", "resultMarkupValueKey", "minCharacters", "onSearch", "onSelect", "onSelectWithData", "searchResults"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const AutoComplete = _ref => {
  let {
      name = 'AutoCompleteField',
      srInstruction = 'Please enter 3 or more characters to search. If you can\'t find a match please select "unknown".',
      ResultMarkup = _ref2 => {
        let {
          result,
          clickHandler
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          value: result.value,
          onClick: () => clickHandler(result)
        }, /*#__PURE__*/_react.default.createElement("strong", null, result.label), /*#__PURE__*/_react.default.createElement("span", null, result.subLabel));
      },
      resultMarkupExtraProps,
      resultMarkupValueKey = 'value',
      // The searchResult's key that used for ResultMarkup button's value
      minCharacters,
      onSearch,
      onSelect,
      onSelectWithData,
      searchResults
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const autoCompleteResultsElement = (0, _react.useRef)(null);
  const autoCompleteWrapperElement = (0, _react.useRef)(null);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isSelectedValue, setIsSelectedValue] = (0, _react.useState)(!!rest.defaultValue);
  const {
    fieldFormContext
  } = rest;
  const ResetField = () => {
    if (fieldFormContext && fieldFormContext.setValue) {
      fieldFormContext.setValue(name, '');
    }
    setIsSelectedValue(false);
    setIsOpen(false);
  };
  const [autoCompleteInputValue, setAutoCompleteInputValue] = (0, _react.useState)(rest.defaultValue);
  (0, _hooks.useOnClickOutside)(autoCompleteWrapperElement, () => {
    if (!isSelectedValue) {
      ResetField();
    }
  });
  (0, _hooks.useOnEdgeProximityDetect)({
    triggerRef: autoCompleteWrapperElement,
    wrapperRef: autoCompleteWrapperElement,
    contentRef: autoCompleteResultsElement,
    requiresRecalc: isOpen
  });
  const resultsListId = "".concat(name, "_AutoCompleteResults");
  const labelId = "".concat(name, "_AutoComplete_label");
  const cssClass = () => {
    if (rest.readOnly) {
      return "formField textField ".concat(rest.customCssClass);
    }
    return "formField textField autoCompleteField autoCompleteFieldFixed ".concat(rest.customCssClass);
  };
  const debouncedChange = (0, _useDebounce.useDebouncedCallback)(event => {
    const searchValue = event.target.value;
    setIsOpen(searchValue !== '');
    setIsSelectedValue(false);
    if (onSearch && searchValue.length >= minCharacters) {
      onSearch(searchValue);
    }
  }, 500, {
    maxWait: 2000
  });
  const HandleSelect = _ref3 => {
    let {
      result,
      inputValue
    } = _ref3;
    if (onSelect) {
      onSelect(result, inputValue);
    }
    if (onSelectWithData) {
      onSelectWithData(result, inputValue);
    }
    setIsSelectedValue(true);
    setIsOpen(false);
    setAutoCompleteInputValue(inputValue);
    if (fieldFormContext && fieldFormContext.setValue) {
      fieldFormContext.setValue(name, inputValue);
    }
  };

  // Handle special key presses inside the input text element
  const HandleSpecialKeyPresses = event => {
    // Escape key
    if (event.keyCode === 27) {
      ResetField();
    }
    const index = searchResults === null || searchResults === void 0 ? void 0 : searchResults.findIndex(result => result[resultMarkupValueKey] === event.target.value);

    // Down arrow
    if (event.keyCode === 40 && isOpen) {
      var _autoCompleteResultsE;
      event.preventDefault();
      (_autoCompleteResultsE = autoCompleteResultsElement.current.querySelectorAll('button')[index || index === 0 ? index + 1 : 0]) === null || _autoCompleteResultsE === void 0 || _autoCompleteResultsE.focus();
    }

    // Up arrow
    if (event.keyCode === 38 && isOpen) {
      var _autoCompleteResultsE2;
      event.preventDefault();
      (_autoCompleteResultsE2 = autoCompleteResultsElement.current.querySelectorAll('button')[index - 1]) === null || _autoCompleteResultsE2 === void 0 || _autoCompleteResultsE2.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: autoCompleteWrapperElement,
    className: cssClass()
  }, /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    name: name,
    autoComplete: "one-time-code",
    disabled: rest.showSpinner,
    srInstruction: srInstruction
  }, rest, {
    labelId: labelId,
    "aria-autocomplete": "list",
    "aria-controls": resultsListId,
    "aria-labelledby": labelId,
    "aria-activedescendant": "",
    "aria-expanded": isOpen,
    role: "combobox",
    inputType: rest.readOnly ? 'text' : 'search',
    defaultValue: autoCompleteInputValue,
    customKeyHandler: HandleSpecialKeyPresses,
    customChangeHandler: event => {
      setAutoCompleteInputValue(event.target.value);
      debouncedChange(event);
    }
  })), isOpen &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  _react.default.createElement("div", {
    "aria-labelledby": labelId,
    id: resultsListId,
    className: "fixedAutoCompleteResultsList ".concat(searchResults && searchResults.length ? 'hasResults' : 'noResults'),
    ref: autoCompleteResultsElement,
    onKeyDown: HandleSpecialKeyPresses
  }, searchResults && searchResults.length > 0 ? searchResults.map((result, index) => /*#__PURE__*/_react.default.createElement(ResultMarkup
  // eslint-disable-next-line react/no-array-index-key
  , _extends({
    key: "acResult_".concat(name, "_").concat(index),
    result: result,
    clickHandler: HandleSelect
  }, resultMarkupExtraProps))) : /*#__PURE__*/_react.default.createElement(_AutoCompleteNoResultsMessage.AutoCompleteNoResultsMessage, {
    label: rest.label
  })));
};
exports.AutoComplete = AutoComplete;
AutoComplete.propTypes = _formFieldPropTypes.AutoCompletePropTypes;
AutoComplete.defaultProps = _objectSpread(_objectSpread({}, _formFieldPropTypes.FormFieldDefaultProps), {}, {
  minCharacters: 3
});
var _default = exports.default = AutoComplete;